export function resolveStoredCompanyId<T extends { id: number }>(
    companies: T[],
    storageKey: string,
    fallbackCompanyId: number
): number {
    try {
        const savedCompanyId = Number(localStorage.getItem(storageKey));
        const exists = companies.some(company => company.id === savedCompanyId);

        return exists ? savedCompanyId : fallbackCompanyId;
    } catch {
        return fallbackCompanyId;
    }
}
